export * from "./ATypeTabs";
export * from "./BTypeTabs";
export * from "./CTypeTabs";
export * from "./DTypeTabs";
